import React from "react";

function diff(oldStr, newStr) {
  // Lightweight line-by-line diff. Good enough for v1; replace with `diff` lib if desired later.
  const o = (oldStr || "").split("\n");
  const n = (newStr || "").split("\n");
  const out = [];
  let i = 0, j = 0;
  while (i < o.length || j < n.length) {
    if (i < o.length && j < n.length && o[i] === n[j]) {
      out.push({ kind: "ctx", text: o[i] }); i++; j++;
    } else if (j < n.length && (i >= o.length || !o.slice(i, i + 5).includes(n[j]))) {
      out.push({ kind: "add", text: n[j] }); j++;
    } else {
      out.push({ kind: "del", text: o[i] }); i++;
    }
  }
  return out;
}

export default function EditTool({ payload, result }) {
  const path = payload?.input?.file_path || "";
  const oldStr = payload?.input?.old_string || "";
  const newStr = payload?.input?.new_string || "";
  const lines = diff(oldStr, newStr);
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Edit</h5>
        <pre className="tool-pre">{path}</pre>
      </div>
      <div className="tool-section">
        <h5>Diff</h5>
        <pre className="tool-pre">
{lines.map((l, idx) => {
  const prefix = l.kind === "add" ? "+" : l.kind === "del" ? "-" : " ";
  const color = l.kind === "add" ? "#3fb950" : l.kind === "del" ? "#f85149" : "inherit";
  return <div key={idx} style={{ color }}>{prefix} {l.text}</div>;
})}
        </pre>
      </div>
      {result && result.is_error && (
        <div className="tool-section">
          <h5>Error</h5>
          <pre className="tool-pre">{result.content_preview}</pre>
        </div>
      )}
    </div>
  );
}
EditTool.summarize = (p) => p?.input?.file_path || "";
